export const headerCell = value => {
  return (
    <div className="cell df aic">
      <span>{value}</span>
    </div>
  )
}